module.exports = __webpack_public_path__ + "media/Video 18.06f6860d.mp4";